import styled from "styled-components";

export const PagesStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 160px);
    align-items: center;
    justify-content: center;
`;
